import { LinkPath, LinkPathItem } from '@kpa/kul';
import { FC, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { ContentResponse } from '../../types/shared';
import styles from './Breadcrumbs.module.css';
import { useAtomValue } from 'jotai';
import { navigationBreadcrumbsAtom } from '@/lib/store/Contentstore';

type BreadcrumbsProps = {
  contentResponse: ContentResponse;
};

const Breadcrumbs: FC<BreadcrumbsProps> = ({ contentResponse }): ReactNode => {
  const breadcrumbs = useAtomValue(navigationBreadcrumbsAtom);
  const nav = useNavigate();

  const redirect = (url: string) => {
    nav(url);
  };

  return breadcrumbs.length > 0 && (
    <LinkPath className={styles.breadcrumbs}>
      {breadcrumbs.map(crumb => (
        <LinkPathItem key={crumb.id.toString()} className={styles.breadcrumbs} href={crumb.url} callback={redirect}>{crumb.name}</LinkPathItem>
      ))}
      <LinkPathItem>{contentResponse.name}</LinkPathItem>
    </LinkPath>
  );
};

export default Breadcrumbs;
